import { uploadMedia } from '../../api/admin';

export const ACCEPTED_IMAGE_TYPES = [
  'image/jpeg',
  'image/png',
  'image/webp',
  'image/gif',
];

export const MAX_IMAGE_SIZE = 5 * 1024 * 1024;

export const getImageFilesFromTransfer = (transfer) => {
  const files = [...(transfer?.files || [])].filter((file) => file.type.startsWith('image/'));
  if (files.length) return files;

  return [...(transfer?.items || [])]
    .filter((item) => item.kind === 'file' && item.type.startsWith('image/'))
    .map((item) => item.getAsFile())
    .filter(Boolean);
};

export const uploadArticleImage = async (file) => {
  if (!file) throw new Error('Choose an image to upload.');
  if (!ACCEPTED_IMAGE_TYPES.includes(file.type)) {
    throw new Error('Only JPG, PNG, WebP, and GIF images are supported.');
  }
  if (file.size > MAX_IMAGE_SIZE) {
    throw new Error('Images must be 5 MB or smaller.');
  }

  try {
    const response = await uploadMedia(file, 'articles');
    if (response.data?.code !== 200) {
      throw new Error(response.data?.message || 'Image upload failed.');
    }

    const publicUrl = response.data?.data?.publicUrl;
    if (!publicUrl) throw new Error('The server did not return an image URL.');
    return publicUrl;
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message || 'Image upload failed.');
  }
};
